export default "__VITE_ASSET__8cb1d061__"